module.exports = __webpack_public_path__ + "img/ais-vision-ai.0ac502e2.jpg";